<template>
    <div>
        <v-dialog persistent v-model="dialog" width="500px">
        <v-card width="800px">
            <v-card-title style="background: #455a64; color: white">
            <!-- <span class="overline font-weight-black;">DXF/JWWデータの内容</span> -->
            <span class="overline font-weight-black;">DXFデータの依頼内容確認</span>
            </v-card-title>
                <v-card-text>
                    <v-container>
                            <v-radio-group
                            v-model="siteLayoutOption"
                            column
                            hide-details
                            class="ml-12">
                            <v-radio
                                label="BOSS送信済み"
                                value="option1">
                            </v-radio>
                            <v-radio
                                label=" 添付ファイル参照（現況図のみ）"
                                value="option2">
                            </v-radio>
                            <v-radio
                                label=" 添付ファイル参照（現況図及び敷地断面図）"
                                value="option3">
                            </v-radio>
                            <!-- <v-radio
                                label="現況図のみ"
                                value="option1"
                                @click="enableCheckbox"
                            ></v-radio>
                            <v-radio
                                label="現況図と敷地断面図・直交図"
                                value="option2"
                                @click="enableCheckbox"
                            ></v-radio> -->
                        </v-radio-group>
                        <div class="mt-2 ml-7 pa-0"> <span style="font-size:16px;font-family:Arial, Helvetica, sans-serif;color:red;">※添付ファイル参照を選択された場合</span></div>
                        <div class="ml-11 pa-0"> <span style="font-size:16px;font-family:Arial, Helvetica, sans-serif;color:red;">送信された現況図データをHRDにてBOSSに送信します。</span></div>

                        <!-- <v-checkbox
                            v-model="bossSite"
                            label="BOSS送信済み"
                            class="ml-12"
                            value="1"
                            :disabled="isCheckboxDisabled"
                            hide-details>
                        </v-checkbox> -->
                        <!-- NEWLY ADDED -->
                        <v-col cols="11" class="mt-4 ml-3 pa-0"><span style="font-size:18px;font-family:Arial, Helvetica, sans-serif;">屋外配管経路図を配置図に反映</span></v-col>
                            <v-radio-group  hide-details row v-model="siteDiagram" class="ml-12">
                                <v-radio label="あり" value="あり"></v-radio>
                                <v-radio label="なし" value="なし"></v-radio>
                            </v-radio-group>
                        
                        <v-col cols="10" class="mt-4 ml-2 pa-0">
                            <span style="font-size:16px;font-family:Arial, Helvetica, sans-serif;color:red;">※BOSSに屋外配管経路図アップロード済み</span>
                        </v-col>
                        <div class="ml-2" style="font-size:16px;font-family:Arial, Helvetica, sans-serif;color:red;">※1回のみ依頼可能。依頼後、修正が必要な場合は配置図に指示。</div>
                        <!-- <div class="ml-2" style="font-size:16px;font-family:Arial, Helvetica, sans-serif;color:red;">※トライアルエリア以外での依頼は不可</div> -->

                        <!-- <v-radio-group v-model="bossRadio" hide-details column class="ml-12" v-if="siteDiagram == 'あり'">
                            <v-radio label="BOSS送信済み" value="1"></v-radio>
                            <v-radio label="CAD依頼添付資料に添付" value="2"></v-radio>
                        </v-radio-group> -->
                        

                    </v-container>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                        <v-btn dark color="red" @click="cancelSubmit">キャンセル</v-btn>
                        <v-btn dark color="green" @click="submitSiteLayout" :disabled="siteLayoutOption == null">保存</v-btn>
            </v-card-actions>
        </v-card>
        </v-dialog>
    </div>
</template>
<script>
import { mapState } from 'vuex';
export default {
    props: {
        dialog: Boolean
    },
    data: () => ({
        siteLayoutOption : null,
        // bossSite : null,
        // isCheckboxDisabled: true,
        siteDiagram : 'なし',
        // bossRadio : null,
    }),
    
    computed:{
    ...mapState([
        'attachments',
        'cadRequestRevisionContent',
        'editMode',
        'editCadRequestRevisionContent',
        'previousAttachmentFiles', 
    ]),
    },

    methods: {
        // enableCheckbox() {
        //     this.isCheckboxDisabled = false;
        // },

    toggleDialogSiteLayout(value){
        this.$emit('toggleDialogSiteLayout', value)
    },
    submitSiteLayout(){
        // if(this.siteLayoutOption){
            const combinedValue = {
                siteLayoutOption: this.siteLayoutOption,
                // bossSite: this.bossSite,
                siteDiagram: this.siteDiagram,
                // bossRadio: this.bossRadio,
            };
        
            this.$emit('submitSiteLayout', combinedValue) 
            // this.$emit('submitSiteLayout', this.siteLayoutOption && this.bossSite) 
            this.toggleDialogSiteLayout(false)
            return;
        // } 
        // else if(!this.bossSite){
        //     alert('Please select Boss Sending!');
        // } else {
        //     alert('Please select one option!');
        // }
        
    },
    cancelSubmit(){
        if(!this.editMode){
            this.siteLayoutOption = null;
            // this.bossSite = null; 
            this.siteDiagram = 'なし';
            // this.bossRadio = null;
            // this.isCheckboxDisabled = true;
            this.$emit('cancelSubmit', null)
            this.toggleDialogSiteLayout(false)
        } else {
            this.toggleDialogSiteLayout(false)
        }
    }
  },
  watch: {
    "$store.state.editCadRequestRevisionContent"(val){   
        // console.log(val)  
        this.siteLayoutOption = val.site_layout_option
        // this.bossSite = val.boss_sending
        this.siteDiagram = val.site_diagram
        // console.log(val,'val')
    },
    // siteLayoutOption(val){
    //     if(val != null){
    //         this.isCheckboxDisabled = false
    //     }else {
    //         this.isCheckboxDisabled = true
    //     }
    // },
  },
};
</script>
<style lang=""></style>
